import PhoneScreenshot from './PhoneScreenshot'

/** CleanDock online booking site — shown on the online booking stage. */
const BookingScreen = () => (
  <PhoneScreenshot src="/LandingPhoneMock/BookingSite.PNG" alt="CleanDock online booking site" />
)

export default BookingScreen
